// src/components/Servicios.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import servicios from "../data/servicios";

const serviciosData = servicios.map((s) => ({
  title: s.title,
  path: `/servicio/${s.slug}`,
  image: s.image,
}));

export default function Servicios() {
  const navigate = useNavigate();

  return (
    <section id="servicios" className="py-20 bg-[#D1D1CF] relative z-0">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-12 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
          Servicios
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 justify-center">
          {serviciosData.map((servicio, idx) => (
            <motion.div
              key={idx}
              className={`relative cursor-pointer rounded-3xl shadow-lg flex items-center justify-center py-10 px-4 overflow-hidden transition-transform duration-300 hover:shadow-xl hover:scale-105 ${
                servicio.image ? "" : "bg-white"
              }`}
              onClick={() => navigate(servicio.path)}
              style={{
                minHeight: "180px",
                ...(servicio.image && {
                  backgroundImage: `url('${servicio.image}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }),
              }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
            >
              {servicio.image && (
                <div className="absolute inset-0 bg-black/50" />
              )}
              <p
                className={`relative z-10 text-base lg:text-lg font-semibold text-center leading-snug ${
                  servicio.image ? "text-white drop-shadow-md" : "text-primary"
                }`}
              >
                {servicio.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
